<div class="app-page" style="padding: 16px;">
  <mat-toolbar style="background-color: var(--mat-sys-background); color: var(--mat-sys-on-background);">
    <button mat-icon-button (click)="back()">
      <mat-icon>arrow_back_ios_new</mat-icon>
    </button>
    <span style="font-weight: 600;">TAGS</span>
    <span class="spacer"></span>
    <button mat-flat-button color="primary" (click)="openCreate()" style="margin-right: 8px;">
      <mat-icon>add</mat-icon>
      NEW TAG
    </button>
    <button mat-icon-button aria-label="Refresh tags" (click)="loadTags()">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-toolbar>

  @if (isLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (isEditorOpen) {
    <mat-card appearance="outlined" style="margin-top: 12px; padding: 12px;">
      <div style="font-weight: 600; margin-bottom: 8px;">{{ editorMode === 'NEW' ? 'Create tag' : 'Edit tag' }}</div>
      <form [formGroup]="tagForm" style="display: flex; flex-wrap: wrap; gap: 12px; align-items: center;">
        <mat-form-field appearance="outline" style="width: 220px;">
          <mat-label>English text</mat-label>
          <input matInput formControlName="TextEnglish" />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 220px;">
          <mat-label>Swedish text</mat-label>
          <input matInput formControlName="TextSwedish" />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 220px;">
          <mat-label>Finnish text</mat-label>
          <input matInput formControlName="TextFinnish" />
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 220px;">
          <mat-label>Tag color</mat-label>
          <mat-select formControlName="TagColor">
            <mat-option value="sc-playertag-green">Green</mat-option>
            <mat-option value="sc-playertag-yellow">Yellow</mat-option>
            <mat-option value="sc-playertag-red">Red</mat-option>
            <mat-option value="sc-playertag-blue">Blue</mat-option>
            <mat-option value="sc-playertag-black">Black</mat-option>
            <mat-option value="sc-playertag-cerise">Cerise</mat-option>
            <mat-option value="sc-playertag-orange">Orange</mat-option>
            <mat-option value="sc-playertag-gray">Gray</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-slide-toggle formControlName="Active">Enabled</mat-slide-toggle>

        <div style="display: flex; gap: 8px; width: 100%;">
          <button mat-flat-button color="primary" (click)="save()" [disabled]="tagForm.invalid">{{ editorMode === 'NEW' ? 'CREATE' : 'SAVE' }}</button>
          <button mat-button type="button" (click)="cancelEdit()">CANCEL</button>
        </div>
      </form>
    </mat-card>
  }

  <div style="margin-top: 12px; overflow: auto;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1" style="width: 100%; min-width: 520px;">
      <ng-container matColumnDef="TagText">
        <th mat-header-cell *matHeaderCellDef>Tag</th>
        <td mat-cell *matCellDef="let tag">
          <span [class]="tag.TagColor" class="tag-preview">{{ tag.Text || tag.TagText }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="Users">
        <th mat-header-cell *matHeaderCellDef style="width: 60px;">Users</th>
        <td mat-cell *matCellDef="let tag" style="width: 60px;">{{ tag.PlayerTagsSecurity?.length || 0 }}</td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let tag">
          <button mat-icon-button aria-label="Edit tag" (click)="openEdit(tag)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button aria-label="Delete tag" (click)="delete(tag)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    @if (!isLoading && dataSource.data.length === 0) {
      <div style="margin-top: 16px; color: gray;">No tags found.</div>
    }
  </div>
</div>
